import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { MapsIcon } from 'src/assets/icons/navigation';
import { Chip, IconButton } from 'src/components/atoms';
import { StyledLabel } from 'src/components/Table/Cells/common';
import { COLORS, UI_ROUTES } from 'src/constants';
import { CellContext } from 'src/lib/tanstack-react-table';
import { SIM_CARD_DETAIL_SCHEMA } from 'src/utils/api/get-sim-card-details';
import { formatBytes } from 'src/utils/helpers/format-bytes';
import { ACTIVATED_SIM_STATUS, getSimHealth, getSimLastSeen } from 'src/utils/helpers/sim-health';

export const SimHealthCell = ({ row }: CellContext<SIM_CARD_DETAIL_SCHEMA, unknown>) => {
  const { t } = useTranslation();
  const { label, isHealthy } = getSimHealth(row.original, t);

  return <Chip label={label} $color={isHealthy ? COLORS.primary : COLORS.warning} size="small" />;
};

export const SimUsageCell = ({ getValue }: CellContext<SIM_CARD_DETAIL_SCHEMA, number>) => (
  <StyledLabel>{formatBytes(getValue())}</StyledLabel>
);

export const SimLastSeenCell = ({ row }: CellContext<SIM_CARD_DETAIL_SCHEMA, unknown>) => {
  const { t } = useTranslation();
  const lastSeen = getSimLastSeen(row.original.last_seen);

  return <StyledLabel>{lastSeen ? lastSeen.fromNow() : t('sim.details.never')}</StyledLabel>;
};

// same height as the map button so rows line up
const StyledEmptyMapCell = styled.div`
  height: 40px;
`;

// the map only shows activated sims that three could locate
export const SimMapCell = ({ row }: CellContext<SIM_CARD_DETAIL_SCHEMA, unknown>) => {
  const sim = row.original;

  const handleClick = (e: React.SyntheticEvent) => {
    e.stopPropagation();
  };

  if (sim.status !== ACTIVATED_SIM_STATUS || sim.not_found) return <StyledEmptyMapCell />;

  return (
    <Link to={`${UI_ROUTES.DEVICE_MAP}?sim=${sim.sim_id}`} onClick={handleClick}>
      <IconButton>
        <MapsIcon />
      </IconButton>
    </Link>
  );
};
